import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import "./index.scss";
import JsonResponse from "../../../../../../../../design/1/js/lib/entity/response/JsonResponse";
import Button, { ButtonType } from "../../../../../../../../design/1/js/templates/atoms/button";
import InfoCircleInverted from "../../../../../../../../design/1/js/templates/atoms/icon/icons/InfoCircleInverted";

interface SwissIdEmailProps {
    actionUrl: string;
    changeLink: string;
    email: string;
    refreshEmail: MutableRefObject<boolean>;
}

const SwissIdEmail = ({
    actionUrl, changeLink, email, refreshEmail,
}: SwissIdEmailProps) => {
    const [currentEmail, setCurrentEmail] = useState(email);
    const baseClassName = 'w-swissid-email';

    const updateSwissIdEmail = async () => {
        let shortDelay = true;
        do {
            await new Promise(resolve => setTimeout(resolve, shortDelay ? 5000 : 30000));
            shortDelay = false;
            try {
                const response = await fetch(actionUrl);
                const content: JsonResponse = await response.json();
                shortDelay = content.success;
                if (content.success) {
                    setCurrentEmail(content.context['email']);
                }
            } catch (error) {
                console.log(error);
            }
        } while (refreshEmail.current);
    }

    useEffect(() => {
        updateSwissIdEmail();

        return () => {
            refreshEmail.current = false;
        }
    }, []);

    return (
        <div className={`${baseClassName}__wrapper p-4 mb-1`}>
            <span className={`d-flex mb-1 align-items-center`}>
                {window.sv_resource.get('plf_onboarding_change_swissid_label')}
                <span className={`ms-1`} data-toggle="tooltip" data-placement="top" title={window.sv_resource.get('plf_onboarding_change_swissid_tooltip')}><InfoCircleInverted/></span>
            </span>
            <div className={`${baseClassName}__container`}>
                <div className={`${baseClassName}__field_container d-flex mw-100`}>
                    <span className={`${baseClassName}__icon flex-shrink-0`}></span>
                    <span className={`${baseClassName}__field py-2 ps-1 pe-3 flex-grow-1 text-truncate`}>{currentEmail}</span>
                </div>
                <Button className={`${baseClassName}__btn text-truncate`} hasArrow={false} href={changeLink} target={`_blank`} type={ButtonType.Gray} text={window.sv_resource.get('plf_onboarding_change_swissid_email')}/>
            </div>
        </div>
    );
};

export default SwissIdEmail;
